import { useState } from 'react'
import { useItem, useList } from '../api/queries'
import type { Area, ExportDataset } from '../api/types'
import { DataTable } from '../components/DataTable'
import { Icon } from '../components/Icon'
import { Card, Field, PageHeader } from '../components/ui'
import { buildQuery } from '../api/client'
import { areaLabel } from '../lib/areas'

const DESCRIPTIONS: Record<string, string> = {
  equipment: 'Todos los equipos con sus especificaciones e indicador de ruta crítica',
  inspections: 'Inspecciones con el desglose por criterio',
  findings: 'Hallazgos y sus órdenes de trabajo',
  'work-orders': 'Órdenes de trabajo con responsable y estado',
  measurements: 'Mediciones eléctricas, reportadas y calculadas',
  'lubrication-events': 'Eventos de lubricación realizados',
  'data-quality': 'Problemas de calidad de datos',
}

export function ExportsPage() {
  const sets = useItem<ExportDataset[]>('/api/exports/')
  const areas = useList<Area>('/api/areas/', { page_size: 50 })
  const [area, setArea] = useState('')
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const href = (key: string, fmt: string) => `/api/exports/${key}/${buildQuery({ fmt, area, date_from: from, date_to: to })}`
  return (
    <div className="page">
      <PageHeader title="Exportaciones" subtitle="CSV y XLSX de los mismos datos que muestran las pantallas" />
      <Card title="Filtros">
        <div className="toolbar">
          <Field label="Área" htmlFor="ex-area"><select id="ex-area" value={area} onChange={(e) => setArea(e.target.value)}><option value="">Todas las áreas</option>{areas.data?.results.map((a) => <option key={a.id} value={a.id}>{areaLabel(a.code, a.name)}</option>)}</select></Field>
          <Field label="Desde" htmlFor="ex-from"><input id="ex-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></Field>
          <Field label="Hasta" htmlFor="ex-to"><input id="ex-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} /></Field>
        </div>
      </Card>
      <Card title="Conjuntos de datos">
        <DataTable caption="Exportaciones" rows={sets.data} loading={sets.isPending} error={sets.error} rowKey={(s) => s.key} columns={[
          { key: 't', header: 'Conjunto de datos', cell: (s) => <><strong>{s.title || s.key}</strong><div className="muted">{DESCRIPTIONS[s.key] ?? ''}</div></> },
          { key: 'c', header: 'Columnas', cell: (s) => s.columns, priority: 'low' },
          { key: 'd', header: 'Descargar', cell: (s) => <span className="row"><a className="btn btn--ghost btn--sm" href={href(s.key, 'csv')}><Icon name="download" size={14} /> CSV<span className="sr-only"> de {s.key}</span></a><a className="btn btn--ghost btn--sm" href={href(s.key, 'xlsx')}><Icon name="download" size={14} /> XLSX<span className="sr-only"> de {s.key}</span></a></span> },
        ]} />
      </Card>
    </div>
  )
}
